<template>
  <div
    class="self-company-shipment-form"
    :style="{ height: pageHeight ? `${pageHeight}px` : null }"
  >
    <el-tabs
      v-model="tabPaneVal"
      class="shipment-tabs"
      type="border-card"
      @tab-click="handleClick"
    >
      <el-tab-pane label="企业资料" name="ShipmentEdit">
        <ShipmentEdit
          v-if="isShipmentEditShow"
          ref="ShipmentEditRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <el-tab-pane v-if="!ctmsShow" label="开票信息管理" name="InvoiceMessage">
        <InvoiceMessage
          v-if="isInvoiceMessageShow"
          ref="InvoiceMessageRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <el-tab-pane label="地址管理" name="CommonRouteInfo">
        <CommonRouteInfo
          v-if="isCommonRouteInfoShow"
          ref="CommonRouteInfoRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <el-tab-pane v-if="!ctmsShow" label="承运分组" name="VehicleTeam">
        <VehicleTeam
          v-if="isVehicleTeamShow"
          ref="VehicleTeamRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <el-tab-pane label="员工管理" name="ShipmentStaff">
        <ShipmentStaff
          v-if="isShipmentStaffShow"
          ref="ShipmentStaffRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <!-- 子公司管理 -->
      <el-tab-pane
        v-if="isHasSub === 0 || isAdmin"
        label="子公司管理"
        name="SubsidiaryManagement"
      >
        <SubsidiaryManagement
          ref="SubsidiaryManagementRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="上游客户管理" name="UpstreamCustomer">
      <UpstreamCustomer v-if="isUpstreamCustomerShow" ref="UpstreamCustomerRef" :parent-data="parentData" />
    </el-tab-pane> -->
      <!-- <el-tab-pane v-if="!ctmsShow" label="合同管理" name="ShipmentContract">
      <ShipmentContract
        v-if="isShipmentContractShow"
        ref="ShipmentContractRef"
        :parent-data="parentData"
      />
    </el-tab-pane> -->
      <el-tab-pane label="权限管理" name="jurisdictManage">
        <jurisdictManage
          v-if="isjurisdictManageShow"
          ref="jurisdictManageRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
      <el-tab-pane label="承运主体" name="shipmentBranch">
        <branchList
          v-if="isshipmentBranchShow"
          ref="shipmentBranchRef"
          :parent-data="parentData"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SubsidiaryManagement from "./SubsidiaryManagement.vue";
import ShipmentEdit from "./components/shipmentEdit.vue";
import InvoiceMessage from "./components/invoiceMessage/invoiceMessageList.vue";
import CommonRouteInfo from "./components/commonRouteInfo/commonRouteInfoList.vue";
import VehicleTeam from "./components/vehicleTeam/vehicleTeamList.vue";
import ShipmentStaff from "./components/shipmentStaff/shipmentStaffList.vue";
// import UpstreamCustomer from "./components/upstreamCustomer/upstreamCustomerList.vue";
import ShipmentContract from "./components/shipmentContract/shipmentContractList.vue";
import jurisdictManage from "./components/jurisdictManage/jurisdictManage";
import branchList from "./components/jurisdictManage/branchList";
import { getListDict, getGoodsTypeDict, getShipperList } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
export default {
  name: "SelfCompanyShipmentForm",
  components: {
    SubsidiaryManagement,
    ShipmentEdit,
    InvoiceMessage,
    CommonRouteInfo,
    VehicleTeam,
    ShipmentStaff,
    // UpstreamCustomer,
    ShipmentContract,
    jurisdictManage,
    branchList
  },
  data() {
    return {
      pageHeight: 0,
      isHasSub: this.$store.state.user.party.companyType,
      isSubsidiaryManagementShow: false,
      parentData: {
        hideCheckbox: true,
        isCompany: true,
        areaOptions: this.$store.state.components.areaOptions,
        goodsTypeList: [],
        typeOptions: [],
        vehicleDictList: [],
        bankOptions: [],
        receiverUserCodeOptions: [],
        upstreamCustomerList: [],
        branchCode: ""
      },
      tabPaneVal: "ShipmentEdit",
      isShipmentEditShow: true,
      isInvoiceMessageShow: false,
      isCommonRouteInfoShow: false,
      isVehicleTeamShow: false,
      isShipmentStaffShow: false,
      isUpstreamCustomerShow: false,
      isPriceSystemShow: false,
      isCustomerManageShow: false,
      isLineManagementShow: false,
      isjurisdictManageShow: false,
      isshipmentBranchShow: false,
      ctmsShow: false,
      isShipmentContractShow: false,
      isAdmin: false
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.ctmsShow = getRole();
    this.parentData.branchCode = this.$store.getters.party.branchCode;
    //标签页的跳转
    const to = this.$route.query.to;
    if (to) {
      this[`is${this.tabPaneVal}Show`] = false;
      this.tabPaneVal = to;
      this[`is${to}Show`] = true;
    }
    // 收票人选项
    getShipperList({ staffTypes: "1,4,6" }).then(response => {
      this.parentData.receiverUserCodeOptions = response.data.records;
    });
    // 上游客户
    getShipperList({ staffType: "5" }).then(response => {
      this.parentData.upstreamCustomerList = response.data.records;
    });
    // 货物类型
    getGoodsTypeDict({ parentCode: "goodsBigType" }).then(response => {
      this.parentData.goodsTypeList = response.data.records;
    });
    // 开票方式、车型、开户银行
    getListDict({ types: "vehicleClassification, bank" }).then(response => {
      this.parentData.vehicleDictList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.bankOptions = response.data.filter(
        item => item.type === "bank"
      )[0]["dictList"];
    });
  },
  mounted() {
    this.updatePageHeight();
    window.addEventListener("resize", this.updatePageHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updatePageHeight);
  },
  methods: {
    updatePageHeight() {
      this.$nextTick(() => {
        const el = this.$el;
        if (!el || !el.getBoundingClientRect) return;
        const top = el.getBoundingClientRect().top;
        // 预留下方间距，避免贴底；header 高度已体现在 top 中
        const bottomGap = 20;
        this.pageHeight = Math.max(window.innerHeight - top - bottomGap, 300);
      });
    },
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
        this.updatePageHeight();
      });
      // 重新获取 上游客户
      if (tab.name === "UpstreamCustomer") {
        getShipperList({ staffType: "5" }).then(response => {
          this.parentData.upstreamCustomerList = response.data.records;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.self-company-shipment-form {
  overflow: hidden;

  .shipment-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    ::v-deep .el-tabs__content {
      flex: 1;
      overflow: auto;
      min-height: 0;
    }

    ::v-deep .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
